import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod/v4';

import { SocialAccountsPage } from '@/features/social-accounts/components/social-accounts-page';
import { requireAuthenticatedRoute } from '@/lib/router-guards';

const socialAccountsSearchSchema = z.object({
    status: z.enum(['success', 'error']).optional(),
    provider: z.string().optional(),
    socialAccountId: z.string().optional(),
    organizationId: z.string().optional(),
    message: z.string().optional()
});

export const Route = createFileRoute('/_app/social-accounts')({
    beforeLoad: requireAuthenticatedRoute,
    component: SocialAccountsPage,
    validateSearch: (search) => socialAccountsSearchSchema.parse(search)
});
